import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectSessionInformation } from '../../redux/slices/sessionSlice';

function RaaRoute({
  component: Component,
  render,
  children,
  minimumTierLevel,
  redirectTo,
  ...routeProps
}) {
  const { activeSubscription } = useSelector(selectSessionInformation);

  const isAboveMinimumTier = activeSubscription
    && activeSubscription.subscriptionTierLevel
    && activeSubscription.subscriptionTierLevel >= minimumTierLevel;

  return (
    <Route
      {...routeProps}
      render={(props) => {
        if (!isAboveMinimumTier) {
          return <Redirect to={redirectTo} />;
        }

        if (Component) {
          return <Component {...props} />;
        }

        if (render) {
          return render(props);
        }

        return React.Children.map(children, (child) => {
          if (!React.isValidElement(child)) {
            return child;
          }

          return React.cloneElement(child, props);
        });
      }}
    />
  );
}

RaaRoute.defaultProps = {
  component: null,
  render: null,
  children: null,
  minimumTierLevel: 0,
  redirectTo: '/s/subscription/billing',
};

RaaRoute.propTypes = {
  component: PropTypes.elementType,
  render: PropTypes.func,
  children: PropTypes.node,
  minimumTierLevel: PropTypes.number,
  redirectTo: PropTypes.string,
};

export default RaaRoute;
